/**
 * @Description 详情
 */

import { FC, forwardRef, useImperativeHandle, useState } from 'react';
import { Spin } from 'antd';
import V2Container from '@/common/components/Data/V2Container';
import { useMethods } from '@lhb/hook';
import DetailMain from './components/DetailMain';
import styles from './entry.module.less';
import { getShopDetail } from '@/common/api/expandStore/shop';

// const Detail: FC<any> = forwardRef(({ id, onClose }, ref) => {
const Detail: FC<any> = forwardRef(({ id, onClose, reload }, ref) => {

  const [loading, setLoading] = useState<boolean>(false);
  const [detail, setDetail] = useState<any>({});

  useImperativeHandle(ref, () => ({
    init: methods.init
  }));


  const methods = useMethods({

    /**
     * @description 初始化
     */
    init: () => {
      if (!id) {
        return;
      }
      methods.loadData(id);
    },

    loadData: async (id: number) => {
      setLoading(true);
      const data = await getShopDetail({ id });
      setLoading(false);
      setDetail(data);
    },
    /**
     * @description 重新加载
     * @param status 状态 true 需要加载详情， false 不需要加载详情
     * @return
     */
    reload(status = true) {
      if (status) methods.init();

      reload?.();
    }
  });



  return (<>
    <Spin tip='数据正在加载中请稍等......' spinning={loading}>
      <V2Container style={{ height: 'calc(100vh - 64px)', width: '100%' }} className={styles.container}>
        <DetailMain detail={detail} onClose={onClose} reload={() => methods.reload(true)}/>
      </V2Container>
    </Spin>
  </>);
});

export default Detail;
